// extracted by mini-css-extract-plugin
module.exports = {"Backdrop":"Backdrop_Backdrop__ygFIT","BackdropSpinner":"Backdrop_BackdropSpinner__2puqk"};